import { MethodType, TokenType, bearerToken, tokenTimedCache } from "./auth";
import { isLocalHost, runningOnRobot } from "./host-aware";

export async function execute(method: MethodType, functionName: string, query: any = {}, params?: any, retries = 1): Promise<any> {
  const token = runningOnRobot() ? 'weirdo_token' : await bearerToken(TokenType.Function);
  const headers = new Headers();
  const isArrayBufferLike = params instanceof ArrayBuffer;
  let requestData: any = params ? { body: JSON.stringify(params) } : {}
  let binaryGet = false;
  if (isArrayBufferLike) {
    headers.append("Content-Type", "application/octet-stream");
    if (method === MethodType.Get) {
      headers.append("Accept", "application/octet-stream");
      requestData = {};
      binaryGet = true;
    } else {
      requestData = { body: params };
    }
  } else {
    headers.append("Content-Type", "application/json");
  }
  const bearer = `Bearer ${token}`;
  headers.append("Authorization", bearer);
  const userToken = runningOnRobot() ? 'weido_user_token' : await bearerToken(TokenType.User);
  headers.append('x-auth-token', userToken);
  const url = buildFunctionUrl(functionName, query);
  // console.log({ url });
  const response = await fetch(
    url,
    {
      method,
      ...requestData,
      headers
    }
  );

  if (!response.ok) {
    console.error('Failed to execute function:', functionName, 'Status:', response.status, 'Message:', response.statusText);
    // console.error('Headers:', response.headers);
    // tokenTimedCache.clear();
    if (retries > 0) {
      console.warn(`Retrying function ${functionName} (${retries} retries left)`);
      return await execute(method, functionName, query, params, retries - 1);
    } else {
      throw new Error(`Failed to execute function ${functionName}: ${response.statusText}`);
    }
  }

  if (binaryGet) {
    return response.arrayBuffer();
  } else {
    return await response.json();
  }
}

export function buildFunctionUrl(functionName: string, query: any = {}) {
  if (runningOnRobot()) {
    let host = isLocalHost() ? 'http://localhost:28802' : '';
    
    return `${host}/functions/${functionName}${Object.keys(query).length ? '?' + new URLSearchParams(query) : ''}`;
  } else {
    return `https://${process.env.REACT_APP_FUNCTION_APP_NAME}.azurewebsites.${process.env.REACT_APP_TLD === 'com' ? 'net' : process.env.REACT_APP_TLD}/api/${functionName}${Object.keys(query).length ? '?' + new URLSearchParams(query) : ''}`;
  }
}
